/*
 * OK BYE v74 : couvercle offert avec le coffret Memory Lane.
 * Réglages : <script id="okbye-lid-config"> (snippets/okbye-cart-config.liquid).
 * - Coffret dans le panier → ajoute 1 couvercle (propriété _okbye_lid) ; la réduction
 *   automatique « Couvercle offert avec le coffret Memory Lane » le met à 0 $.
 * - Plus de coffret → retire le couvercle offert. Toujours 1 seul couvercle offert.
 */
(function () {
  var el = document.getElementById('okbye-lid-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg || !cfg.enabled || !cfg.trigger || !cfg.lidVariant) return;
  // v77 : le coffret + les bundles qui le contiennent
  var triggers = (cfg.triggers && cfg.triggers.length ? cfg.triggers : [cfg.trigger]).map(Number);

  var busy = false;
  var timer = null;
  var nativeFetch = window.fetch.bind(window);

  function post(url, body) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Okbye-Lid': '1' },
      body: JSON.stringify(body)
    });
  }

  function refreshDrawer() {
    return nativeFetch('/?sections=mini-cart')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['mini-cart'];
        var box = document.getElementById('mini-cart');
        if (html && box) {
          var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (sec) box.innerHTML = sec.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('okbye:cart-refreshed'));
      })
      .catch(function () {});
  }

  function sync() {
    if (busy) { schedule(600); return; }
    busy = true;
    nativeFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasTrigger = false;
        var lidLines = [];
        cart.items.forEach(function (it) {
          if (triggers.indexOf(Number(it.product_id)) !== -1) hasTrigger = true;
          if (it.properties && it.properties._okbye_lid) lidLines.push(it);
        });
        if (hasTrigger && !lidLines.length) {
          var props = { _okbye_lid: 'true' };
          if (cfg.note) props[cfg.noteKey || 'Cadeau'] = cfg.note;
          return post('/cart/add.js', { items: [{ id: Number(cfg.lidVariant), quantity: 1, properties: props }] }).then(refreshDrawer);
        }
        var updates = {};
        var change = false;
        lidLines.forEach(function (it, i) {
          var want = hasTrigger && i === 0 ? 1 : 0;
          if (it.quantity !== want) { updates[it.key] = want; change = true; }
        });
        if (change) return post('/cart/update.js', { updates: updates }).then(refreshDrawer);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sync, ms || 450); }

  // Réagit à tout ajout / changement du panier fait par le thème ou les apps
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-Okbye-Lid'] || (init.headers.get && init.headers.get('X-Okbye-Lid')));
    var p = nativeFetch(input, init);
    if (!mine && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };

  document.addEventListener('DOMContentLoaded', function () { schedule(300); });
  if (document.readyState !== 'loading') schedule(300);
})();
